import { render } from "./EditEmailSettings.vue?vue&type=template&id=0d4c083f&scoped=true"
import script from "./EditEmailSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditEmailSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditEmailSettings.vue?vue&type=style&index=0&id=0d4c083f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4c083f"]])

export default __exports__